export const getRandomUserLogin = () => `user-${Math.floor(Math.random() * 1000)}`;
